import axios from 'axios'

let token = localStorage.getItem('accesstoken')
if (token) {
  axios.defaults.headers.common['accesstoken'] = `Bearer ${token}`
}
// TODO: implement env file to store all different api end-point for each environment
export const httpInstance = axios.create({
  baseURL: 'http://api.eapproval.chipmong.com:9101',
  // baseURL: 'http://api.eapprovalqas.chipmong.com:8181',
  // baseURL: 'http://api.eapprovaldev.chipmong.com:9102',
  headers: {
    'content-type': 'application/json',
    deviceid: '123456'
  }
})

export const pictureUploadInstance = axios.create({
  baseURL: 'http://api.eapproval.chipmong.com:9101',
  headers: {
    'content-type': 'multipart/form-data',
    deviceid: '123456'
  }
})



// WEBPACK FOOTER //
// ./src/api/index.js